"use strict";

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InvalidationPolicyCache_1 = __importDefault(require("../cache/InvalidationPolicyCache"));

var CacheResultProcessor_1 = require("../cache/CacheResultProcessor");

var InvalidationPolicyManagerAuditor_1 = __importDefault(require("./InvalidationPolicyManagerAuditor"));

var EntityTypeMapAuditor_1 = __importDefault(require("./EntityTypeMapAuditor"));

var AuditLog_1 = __importDefault(require("./AuditLog"));

var entity_store_1 = require("../entity-store");

var InvalidationPolicyCacheAuditor = /*#__PURE__*/function (_InvalidationPolicyCa) {
  _inherits(InvalidationPolicyCacheAuditor, _InvalidationPolicyCa);

  var _super = _createSuper(InvalidationPolicyCacheAuditor);

  function InvalidationPolicyCacheAuditor(config) {
    var _this;

    _classCallCheck(this, InvalidationPolicyCacheAuditor);

    _this = _super.call(this, config);
    _this.auditLog = new AuditLog_1.default();
    var _config$invalidationP = config.invalidationPolicies,
        invalidationPolicies = _config$invalidationP === void 0 ? {} : _config$invalidationP;
    _this.entityTypeMap = new EntityTypeMapAuditor_1.default({
      auditLog: _this.auditLog
    });
    new entity_store_1.EntityStoreWatcher({
      entityStore: _this.entityStoreRoot,
      entityTypeMap: _this.entityTypeMap,
      policies: _this.policies
    });
    _this.invalidationPolicyManager = new InvalidationPolicyManagerAuditor_1.default({
      auditLog: _this.auditLog,
      policies: invalidationPolicies,
      entityTypeMap: _this.entityTypeMap,
      cacheOperations: {
        evict: _this.evict.bind(_assertThisInitialized(_this)),
        modify: _this.modify.bind(_assertThisInitialized(_this)),
        readField: _this.readField.bind(_assertThisInitialized(_this))
      }
    });
    _this.cacheResultProcessor = new CacheResultProcessor_1.CacheResultProcessor({
      invalidationPolicyManager: _this.invalidationPolicyManager,
      entityTypeMap: _this.entityTypeMap,
      cache: _assertThisInitialized(_this)
    });
    return _this;
  }

  return _createClass(InvalidationPolicyCacheAuditor);
}(InvalidationPolicyCache_1.default);

exports.default = InvalidationPolicyCacheAuditor;